import { httpsCallable } from 'firebase/functions';
import { functions } from '../config/firebase-config';

export const adminCreateUser = async (payload: {
  email: string;
  password: string;
  firstName?: string;
  lastName?: string;
  features?: Record<string, boolean>;
  bootstrapAccess?: { companies?: { companyId: string; level: number }[] }
}) => {
  const fn = httpsCallable<typeof payload, { uid: string }>(functions, 'admin_create_user');
  const res = await fn(payload);
  return res.data;
}

export const adminToggleSuperadmin = async (payload: { uid: string; superadmin: boolean }) => {
  const fn = httpsCallable<typeof payload, null>(functions, 'admin_toggle_superadmin');
  await fn(payload);
}

export const adminSetFeatures = async (payload: { uid: string; features: Record<string, boolean> }) => {
  const fn = httpsCallable<typeof payload, null>(functions, 'admin_set_features');
  await fn(payload);
}

export const adminGrantCompany = async (payload: { uid: string; companyId: string; level: number }) => {
  const fn = httpsCallable<typeof payload, null>(functions, 'admin_grant_company');
  await fn(payload);
}

export const adminGrantCompanyAll = async (payload: { uid: string; level: number }) => {
  const fn = httpsCallable<typeof payload, null>(functions, 'admin_grant_company_all');
  await fn(payload);
}

export const adminMigrateShopifyToCompanies = async (payload: {
  dryRun?: boolean;
  copyProducts?: boolean;
  copyMedia?: boolean;
  copyCredentials?: boolean;
  defaultLevel?: number;
  limit?: number;
  startAfter?: string;
}) => {
  const fn = httpsCallable<typeof payload, any>(functions, 'admin_migrate_shopify_to_companies');
  const res = await fn(payload);
  return res.data;
}

export interface AdminGenerationActivityRow {
  companyId: string;
  companyName: string;
  totalCount: number;
  successfulCount: number;
  failedCount: number;
  generationCounts: Record<string, number>;
}

export interface AdminGenerationActivityTotals {
  companyCount: number;
  totalCount: number;
  successfulCount: number;
  failedCount: number;
  generationCounts: Record<string, number>;
}

export interface AdminGenerationActivityResponse {
  startDate: string;
  endDateExclusive: string;
  items: AdminGenerationActivityRow[];
  totals: AdminGenerationActivityTotals;
}

export const adminGetGenerationActivity = async (payload: {
  startDate: string;
  endDateExclusive: string;
}): Promise<AdminGenerationActivityResponse> => {
  const fn = httpsCallable<typeof payload, AdminGenerationActivityResponse>(functions, 'admin_generation_activity');
  const res = await fn(payload);
  const body = res.data as AdminGenerationActivityResponse | { data?: AdminGenerationActivityResponse };
  if ('data' in body && body.data) {
    return body.data;
  }
  return body as AdminGenerationActivityResponse;
}

// Listing now done via direct Firestore reads in the client (see AdminCenterPage)
